import React from 'react';
import twitchImage from './../images/twitchLogoSquare.png';
import youtubeImage from './../images/youtubeLogoSquare.png';

// Icono de la plataforma del usuario. Por defecto Twitch, que es lo que habia siempre; si la
// fila viene de alguien sin Twitch pero con canal de YouTube, enlaza a su canal.
const TwitchLink = ({displayname, usert, useryt}) => {
    if (!usert && useryt) {
        return (
            <a href={'https://www.youtube.com/channel/' + useryt} target='_blank' rel='noreferrer'><img className='socialImage' src={youtubeImage} alt='YouTube'></img></a>
        )
    }
    return (
        <a href={'https://www.twitch.tv/' + displayname} target='_blank' rel='noreferrer'><img className='socialImage' src={twitchImage} alt='Twitch'></img></a>
    )
}

export default TwitchLink;
